export function getOptionLabel(options, value) {
    const regex = /\[\d+(,\d+)*\]/;

    if (regex.test(value)) {
        const parsedValue = JSON.parse(value)
        let label = ""
        for (const id of parsedValue) {
            label += options?.find(x => x.value == id)?.label + ", "
        }

        return label
    } else {
        return options?.find(x => x.value == value)?.label
    }
}